// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"0cac1e4d","252":"45697697","258":"ae8875b0","280":"44bc6268","492":"4a8c50f0","515":"1883315f","529":"310c9c64","556":"26e69ed1","629":"9ff24f08","631":"c498de91","710":"9aaf55d1","845":"7a89a983","878":"7655386e","881":"83e33b3a","890":"e845385d"}[chunkId] + ".chunk.js";
};